export const getDefaultContractsFields = (fields: string[]) => {
  return fields.reduce(
    (acc, field) => {
      acc[field] = false;
      return acc;
    },
    {} as Record<string, boolean>
  );
};
